(() => {
  const root = document.querySelector('[data-qv143-catalog]');
  if (!root) return;

  const revealNodes = [...root.querySelectorAll('[data-qv143-reveal]')];
  root.classList.add('qv143-ready');

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -28px 0px' });
    revealNodes.forEach((node) => io.observe(node));
  } else {
    revealNodes.forEach((node) => node.classList.add('is-visible'));
  }

  if (!window.matchMedia('(pointer:fine)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  root.querySelectorAll('[data-qv143-card]').forEach((card) => {
    card.addEventListener('pointermove', (event) => {
      const rect = card.getBoundingClientRect();
      card.style.setProperty('--qv143-x', `${event.clientX - rect.left}px`);
      card.style.setProperty('--qv143-y', `${event.clientY - rect.top}px`);
    }, { passive: true });
  });

  root.querySelectorAll('[data-qv143-magnetic]').forEach((button) => {
    button.addEventListener('pointermove', (event) => {
      const rect = button.getBoundingClientRect();
      const dx = ((event.clientX - rect.left) / rect.width - 0.5) * 5;
      const dy = ((event.clientY - rect.top) / rect.height - 0.5) * 4;
      button.style.transform = `translate(${dx}px, ${dy - 2}px)`;
    }, { passive: true });
    button.addEventListener('pointerleave', () => { button.style.transform = ''; }, { passive: true });
  });
})();
